import type * as React from "react";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { AuditLogList, type AuditEventRow } from "./AuditLogList";
import { BeGapBanner } from "./_shared";

/**
 * Audit tab — per-org audit log.
 *
 * v1 reference: ``ando-frontend/app/admin-v2/components/pages/
 * organizations/components/AuditLogList.tsx`` (stub) +
 * ``OrgAuditTab.tsx``. The BE endpoint
 * ``GET /platform-admin/organizations/{id}/audit-log`` is NOT shipped
 * yet (only the user-scoped ``GET /gdpr/audit-log`` exists).
 *
 * v2 wires the full ``<AuditLogList>`` (sortable / searchable /
 * paginated) so the table lights up the second BE ships the endpoint.
 * Until then we render the empty state below the gap banner.
 *
 * TODO Stream BE — implement
 *   ``GET /platform-admin/organizations/{org_id}/audit-log``
 *   with the shape ``{ items: AuditEvent[], total: int, page: int }``
 *   then swap ``EMPTY_ROWS`` for a TanStack Query hook.
 */

const EMPTY_ROWS: AuditEventRow[] = [];

export interface OrgAuditTabProps {
  // Kept for future use — once the BE endpoint lands the orgId will
  // drive the TanStack Query key.
  orgId: string;
}

export function OrgAuditTab(_props: OrgAuditTabProps): React.ReactElement {
  const { i18n } = useLingui();
  return (
    <div className="flex flex-col gap-3">
      <BeGapBanner
        message={
          <>
            {i18n._(msg`Endpoint`)}{" "}
            <code className="font-mono">
              GET /platform-admin/organizations/{"{id}"}/audit-log
            </code>{" "}
            {i18n._(
              msg`non ancora esposto. La tabella è pronta e si popola automaticamente quando il BE espone il rotolo eventi.`,
            )}
          </>
        }
      />
      <AuditLogList
        rows={EMPTY_ROWS}
        emptyHint={i18n._(
          msg`Il backend non ha ancora esposto l'endpoint dedicato — l'UI è pronta per la prima release.`,
        )}
      />
    </div>
  );
}
